import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import styles from './notificationComponent.scss'
import PropTypes from 'prop-types'
import HtmlReactParser from 'html-react-parser'
export function Notification (props: Props) {
  const { t } = props
  return (
    <div>
      {props.notification.icon && (
        <img
          alt={`${props.notification.icon} Emoji`}
          src={require(`../../assets/images/imgEmoji${props.notification
            .icon}.png`)}
          srcSet={
            require(`../../assets/images/imgEmoji${props.notification
              .icon}@2x.png`) +
            ' 2x,' +
            require(`../../assets/images/imgEmoji${props.notification
              .icon}@3x.png`) +
            ' 3x'
          }
          className={styles.icon}
        />
      )}
      <h1 className={styles.h2}>
        {t(`notification:${props.notification.header}`)}
      </h1>
      <p>{HtmlReactParser(t(`notification:${props.notification.text}`))}</p>
      {props.notification.secondText &&
        !Array.isArray(props.notification.secondText) && (
          <p>{t(`notification:${props.notification.secondText}`)}</p>
        )}
      {props.notification.secondText &&
        Array.isArray(props.notification.secondText) &&
        props.notification.secondText.map((text, index) => (
          <p key={index}>{t(`notification:${text}`)}</p>
        ))}
      <button
        className={styles.bigButton}
        onClick={() => {
          props.onClick && props.onClick()
          props.notification.onClose && props.notification.onClose()
        }}
      >
        {t(`notification:${props.notification.buttonText}`)}
      </button>

      {props.notification.dismissText && (
        <button
          onClick={() => {
            props.onClick && props.onClick()
            props.notification.dismissFunc && props.notification.dismissFunc()
          }}
          className={styles.linkText}
        >
          {t(`notification:${props.notification.dismissText}`)}
        </button>
      )}
    </div>
  )
}
Notification.propTypes = {
  t: PropTypes.func.isRequired,
  notification: PropTypes.shape({
    header: PropTypes.string,
    text: PropTypes.string,
    secondText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    buttonText: PropTypes.string,
    icon: PropTypes.string,
    onClose: PropTypes.func,
    dismissText: PropTypes.string,
    dismissFunc: PropTypes.func
  }),
  onClick: PropTypes.func
}

export default compose(pure, translate())(Notification)



// WEBPACK FOOTER //
// ./src/components/notification/notificationComponent.js